export function createExitButton(scene) {

    const closeBtn = scene.add.image(
        40,
        40,
        'closeButton'
    );

    closeBtn
        .setDisplaySize(20, 20)
        .setOrigin(0.5)
        .setScrollFactor(0)
        .setDepth(9999)
        .setInteractive({
            useHandCursor: true
        });

    /*
    closeBtn.on('pointerover', () => {
        closeBtn.setScale(1.05);
    });

    closeBtn.on('pointerout', () => {
        closeBtn.setScale(1);
    });
    */

    closeBtn.on('pointerdown', () => {
        console.log('onExit', scene.onExit);
        scene.onExit?.();
    });

    /*
     * Store the button on the scene so its texture
     * can be changed when the player wins.
     */
    scene.closeButton = closeBtn;

    return closeBtn;
}


export function setExitButtonWinningState(scene) {

    if (!scene.closeButton) {
        return;
    }

    scene.closeButton.setTexture('closeButtonWhite');
}


export function resetExitButton(scene) {

    if (!scene.closeButton) {
        return;
    }

    scene.closeButton.setTexture('closeButton');
}